import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';
import { withTheme } from 'common/styling/theme';
import { EditIcon, CopyIcon } from 'common/icons';

import {
  PageLayout,
  PageContentPreloader,
  ActionsButton,
  StatusCell,
  BasicModal,
  DefaultButton,
  Tooltip,
  PaymentTag,
} from 'common/components';
import {
  EditAmountForm,
  UserDepositProofForm,
  EditTagsForm,
  EditWithdrawalFieldForm,
} from 'backoffice/payments/_components';
import {
  UserInfoPanel,
  OperationsHistory,
  UserTransactionsHistory,
  UserTradingHistory,
  UserAmountEditHistory,
  PaymentNotes,
} from 'backoffice/_components';

import TooltipIcon from 'welcome-setup/_components/icons/TooltipIcon';

import { NavLink } from 'react-router-dom';
import EditPaymentManagerForm from 'backoffice/payments/_components/EditPaymentManagerForm';
import EditAdditionalFieldsForm from 'backoffice/payments/_components/EditAdditionalFieldsForm';
import { getCountries } from 'client/KYC/api';
import { staticStyles, getDynamicStyles } from './style';
import EditBonusRateForm from './EditBonusRateForm';

const PaymentPage = ({
  type,
  itemId,
  captionSlug,
  item,
  perms,
  itemIsLoaded,
  getItem,
  Buttons,
  history,
  addons,
  features,
  hasEditPerm,
  hasEditBonusRatePerm,
  hasEditMetadataPerm,
  hasEditStatusPerm,
  hasEditTagsPerm,
  idBackTo,
  leanpaySources,
  theme,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenManagerForm, setIsOpenManagerForm] = useState(false);
  const [isOpenAdditionalFieldsForm, setIsOpenAdditionalFieldsForm] = useState(false);
  const [isBonusRateModalOpened, setIsBonusRateModalOpened] = useState(false);
  const [bonusRateModalTitle, setBonusRateModalTitle] = useState('');
  const [isMailCopied, setIsMailCopied] = useState(false);
  const [isEditTagsModalOpened, setIsEditTagsModalOpened] = useState(false);
  const [textId, setTextId] = useState('');
  const [fieldName, setFieldName] = useState('');
  const [fieldValue, setFieldValue] = useState('');
  const [isEditWithdrawalFieldOpen, setIsEditWithdrawalFieldOpen] = useState(false);
  const [editFieldKey, setEditFieldKey] = useState('');
  const [editFieldType, setEditFieldType] = useState('text');
  const [editFieldOptions, setEditFieldOptions] = useState([]);
  const [editFieldInitialValue, setEditFieldInitialValue] = useState('');
  const [countries, setCountries] = useState([]);
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  const getMetadataTextId = key => {
    const map = {
      status: 'justStatus',
      beneficiary_name: 'justBeneficiaryName',
      iban_number: 'justIBANNumber',
      address: 'justAddress',
      city: 'justCity',
      country: 'justCountry',
    };
    return map[key] || key;
  };

  // Reverse mapping: translate display keys (e.g. justBeneficiaryName) back to backend API keys
  const getMetadataApiKey = key => {
    const map = {
      justBeneficiaryName: 'beneficiary_name',
      justIBANNumber: 'iban_number',
      justAddress: 'address',
      justCity: 'city',
      justCountry: 'country',
    };
    return map[key] || key;
  };

  const STATUS_OPTIONS = [
    { value: 'waiting_approval', label: 'Waiting for approval' },
    { value: 'waiting_confirmation', label: 'Waiting for confirmation' },
    { value: 'processing', label: 'Processing' },
    { value: 'payout', label: 'PAYOUT' },
    { value: 'done', label: 'DONE' },
    { value: 'rejected', label: 'REJECTED' },
    { value: 'canceled', label: 'CANCELED' },
    { value: 'failed', label: 'FAILED' },
  ];

  const goToUser = () => history.push(`/backoffice/users/${item.user.id}`);
  const isWithdrawal = window.location.pathname.includes('withdrawals');
  const isWithdrawalDone = isWithdrawal && item?.status === 'done';

  useEffect(() => {
    if (isWithdrawal) {
      getCountries().then(res => {
        if (res && res.data) {
          setCountries(res.data.map(c => ({ value: c.country_code_iso3 || c.country_code || c.name, label: c.name })));
        }
      });
    }
  }, []);

  const handleBackToClick = () => {
    // TODO: тк у withdrawals все выводы находятся по пути с list в отдельной вкладке пока
    if (type === 'withdrawals') {
      history.push(`/backoffice/${type}/list`);
    } else {
      history.push(`/backoffice/${type}/`);
    }
  };

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };
  const toggleManagerModal = () => {
    setIsOpenManagerForm(!isOpenManagerForm);
  };

  const toggleAdditionalFieldsModal = () => {
    setIsOpenAdditionalFieldsForm(open => !open);
  };

  const toggleBonusRateModal = () => {
    if (isBonusRateModalOpened) {
      setBonusRateModalTitle('');
    }
    setIsBonusRateModalOpened(!isBonusRateModalOpened);
  };

  const toggleEditTagsModal = () => {
    setIsEditTagsModalOpened(isOpen => !isOpen);
  };

  const onEditDepositAmountModal = () => {
    toggleModal();
  };
  const onEditAdditionFieldsModal = (textId, fieldName, fieldValue) => {
    toggleAdditionalFieldsModal();
    if (textId && fieldName) {
      setTextId(textId);
      setFieldName(fieldName);
      setFieldValue(fieldValue);
    }
  };

  const onEditManagerModal = () => {
    toggleManagerModal();
  };

  const toggleEditWithdrawalFieldModal = () => {
    setIsEditWithdrawalFieldOpen(open => !open);
  };

  const onEditWithdrawalField = (key, type, value) => {
    setEditFieldKey(key);
    setEditFieldType(type);
    setEditFieldInitialValue(value || '');
    if (key === 'status') {
      setEditFieldOptions(STATUS_OPTIONS);
    } else if (key === 'country' || key === 'justCountry') {
      setEditFieldOptions(countries);
    } else if (key && key.toLowerCase().includes('iban')) {
      setEditFieldOptions(leanpaySources || []);
    }
    setIsEditWithdrawalFieldOpen(true);
  };

  const handleMailCopyClick = useCallback(
    email => {
      navigator.clipboard.writeText(email);
      setIsMailCopied(true);

      setTimeout(() => {
        setIsMailCopied(false);
      }, 2000);
    },
    [isMailCopied]
  );

  const walletAddon = addons.includes('walletAccount');
  const additionalFields = item.psAdditionalFields && Object.entries(item.psAdditionalFields);

  return (
    <PageLayout captionSlug={captionSlug} showReload onReloadClick={() => getItem(itemId)} reloading={!itemIsLoaded}>
      <PageContentPreloader ready={itemIsLoaded} type="boPaymentPage">
        {/* eslint-disable */}
        <FormattedMessage id={idBackTo}>
          {txt => (
            <div className="PaymentPage__back-to" onClick={handleBackToClick}>
              {txt}
            </div>
          )}
        </FormattedMessage>
        {/* eslint-enable */}
        <div id={`backoffice-${type}-page-details`} className="PaymentPage__top-info">
          <ul className="PaymentPage__top-info-list">
            {/* Amount */}
            {item?.amountWithCommission?.amount && item?.amountWithCommission?.currency && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-amount`}>
                <FormattedMessage id="boAmount" />
                <div>
                  {item.requestedAmount ? item.requestedAmount.amount : item.amountWithCommission.amount}
                  {item.requestedAmount ? item.requestedAmount.currency : item.amountWithCommission.currency}
                  {item.canEditValue && hasEditPerm && (
                    <ActionsButton edit buttonId="actionsEditValue" onClickFunc={onEditDepositAmountModal}>
                      <EditIcon />
                    </ActionsButton>
                  )}
                </div>
              </li>
            )}
            {/* operation Id */}
            {itemId && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-id`}>
                <FormattedMessage id="boId" />
                <div>{itemId}</div>
              </li>
            )}

            {/* FullName */}
            {item?.user?.fullName && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-fullName`}>
                <FormattedMessage id="justFullName" />
                <div>{item.user.fullName}</div>
              </li>
            )}

            {/* Email */}
            {item?.user?.email && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-email`}>
                <FormattedMessage id="justEmail" />
                <div className="email">
                  {item.user.email}
                  <ActionsButton
                    tooltipId="email-copy-tooltip"
                    tooltipTextId={isMailCopied ? 'justCopiedWord' : 'justCopy'}
                    edit
                    buttonId="actionsCopyValue"
                    onClickFunc={() => handleMailCopyClick(item.user.email)}>
                    <CopyIcon />
                  </ActionsButton>
                </div>
              </li>
            )}

            {/* Account */}
            {item?.account?.login && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-account`}>
                <FormattedMessage id="boAccount" />
                <div>{item.account.login}</div>
              </li>
            )}

            {/* Commission */}
            {item?.commission && (
              <li id={`backoffice-${type}-page-detail-comission`} className="PaymentPage__top-info-item">
                <FormattedMessage id="justRequestedCommission" />
                <div>
                  {item.requestedCommission ? item.requestedCommission.amount : item.commission.amount}
                  {item.requestedCommission ? item.requestedCommission.currency : item.commission.currency}
                </div>
              </li>
            )}

            {/* Convertation course */}
            {item?.exchangeString && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-convertation-course`}>
                <FormattedMessage id="justConvertationCourse" />
                <div>{item.exchangeString}</div>
              </li>
            )}

            {/* Payment system */}
            {item?.paymentSystemSlug && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-payment-system`}>
                <FormattedMessage id="boPaymentSystem" />
                <div>{item.paymentSystemSlug}</div>
              </li>
            )}

            {/* Payment Method */}
            {item?.paymentMethodTitle && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-payment-method`}>
                <FormattedMessage id="boPaymentMethod" />
                <div>{item.paymentMethodTitle}</div>
              </li>
            )}

            {/* Balance */}
            {item?.account?.balance?.amount && item?.account?.balance?.currency && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-balance`}>
                <FormattedMessage id="boBalance" />
                <div>
                  {item.account.balance.amount} {item.account.balance.currency}
                </div>
              </li>
            )}

            {/* Equity */}
            {item?.account?.equity?.amount && item?.account?.equity?.currency && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-equity`}>
                <FormattedMessage id="boEquity" />
                <div>
                  {item.account.equity.amount} {item.account.equity.currency}
                </div>
              </li>
            )}

            {/* wallet-balance */}
            {walletAddon && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-wallet-balance`}>
                <FormattedMessage id="justWalletBalance" />
                <div>{item?.user?.walletBalance} USD</div>
              </li>
            )}

            {/* old wallet-balance */}
            {walletAddon && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-old-wallet-balance`}>
                <div className="PaymentPage__top-info-item-oldWallet">
                  <FormattedMessage id="justOldWalletBalance" />
                  <div className="PaymentPage__top-info-item-oldWallet-tooltip">
                    <Tooltip textId="oldWalletBalanceTooltip">
                      <TooltipIcon />
                    </Tooltip>
                  </div>
                </div>
                <div>
                  {item?.oldWalletBalance?.amount} {item?.oldWalletBalance?.currency}
                </div>
              </li>
            )}

            {/* Status */}
            <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-status`}>
              <FormattedMessage id="justStatus" />
              <div>
                <StatusCell statusCode={item.status} />
                {isWithdrawal && hasEditStatusPerm && !isWithdrawalDone && (
                  <ActionsButton
                    edit
                    buttonId="actionsEditValue"
                    onClickFunc={() => onEditWithdrawalField('status', 'select', item.status)}>
                    <EditIcon />
                  </ActionsButton>
                )}
              </div>
            </li>

            {/* Payment operation manager */}
            {features.includes('paymentOperationManager') && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-operation-manager`}>
                <FormattedMessage id="boInvestManager" />
                <div>
                  {item.manager ? `${item.manager.firstName} ${item.manager.lastName}` : '-'}
                  {hasEditPerm && (
                    <ActionsButton edit buttonId="actionsEditValue" onClickFunc={onEditManagerModal}>
                      <EditIcon />
                    </ActionsButton>
                  )}
                </div>
              </li>
            )}

            {/* additional-fields */}
            {additionalFields &&
              additionalFields.map(item => {
                const WITHDRAWAL_TEXT_FIELDS = [
                  'beneficiary_name',
                  'address',
                  'city',
                  'justBeneficiaryName',
                  'justAddress',
                  'justCity',
                ];
                const isWithdrawalTextField = isWithdrawal && WITHDRAWAL_TEXT_FIELDS.includes(item[0]);
                const isWithdrawalCountryField = isWithdrawal && (item[0] === 'country' || item[0] === 'justCountry');
                const isWithdrawalIbanField = isWithdrawal && item[0] && item[0].toLowerCase().includes('iban');

                return typeof item[1].value !== 'object' || item[1].value === null ? (
                  <li
                    className="PaymentPage__top-info-item"
                    key={item[1].name}
                    id={`backoffice-${type}-page-additional-field`}>
                    <FormattedMessage id={item[1].name} />
                    <div>
                      {item[1].value ? item[1].value : '-'}
                      {hasEditPerm && !isWithdrawalTextField && !isWithdrawalCountryField && !isWithdrawalIbanField && (
                        <ActionsButton
                          edit
                          buttonId="actionsEditValue"
                          onClickFunc={() => onEditAdditionFieldsModal(item[1].name, item[0], item[1].value)}>
                          <EditIcon />
                        </ActionsButton>
                      )}
                      {hasEditPerm && isWithdrawalTextField && !isWithdrawalDone && (
                        <ActionsButton
                          edit
                          buttonId="actionsEditValue"
                          onClickFunc={() => onEditWithdrawalField(item[0], 'text', item[1].value)}>
                          <EditIcon />
                        </ActionsButton>
                      )}
                      {hasEditPerm && isWithdrawalCountryField && !isWithdrawalDone && (
                        <ActionsButton
                          edit
                          buttonId="actionsEditValue"
                          onClickFunc={() => onEditWithdrawalField('country', 'select', item[1].value)}>
                          <EditIcon />
                        </ActionsButton>
                      )}
                      {hasEditPerm && isWithdrawalIbanField && !isWithdrawalDone && (
                        <ActionsButton
                          edit
                          buttonId="actionsEditValue"
                          onClickFunc={() => onEditWithdrawalField(item[0], 'creatable', item[1].value)}>
                          <EditIcon />
                        </ActionsButton>
                      )}
                    </div>
                  </li>
                ) : null;
              })}

            {/* Address */}
            {!isWithdrawal && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-address`}>
                <FormattedMessage id="boAddress" />
                <div>{item?.address ? item.address : '-'}</div>
              </li>
            )}

            {/* Received Amount */}
            {item?.requestedAmount && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-received-amount`}>
                <FormattedMessage id="boReceivedAmount" />
                <div>
                  {item.isReceived || item.status === 'deposited' ? item.amount.amount : '-'}
                  {item.isReceived || item.status === 'deposited' ? item.amount.currency : ''}
                </div>
              </li>
            )}

            {/* Commission */}
            {item?.requestedAmount && (
              <li id={`backoffice-${type}-page-detail-comission`} className="PaymentPage__top-info-item">
                <FormattedMessage id="justReceivedCommission" />
                <div>
                  {item.isReceived || item.status === 'deposited' ? item.commission.amount : '-'}
                  {item.isReceived || item.status === 'deposited' ? item.commission.currency : ''}
                </div>
              </li>
            )}

            {/* Bonus Rate */}
            {!isWithdrawal && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-bonus-rate`}>
                <div>Bonus Rate</div>
                <div>
                  {!item.account || !item.bonusRate ? '-' : `${item.bonusRate}%`}
                  {hasEditBonusRatePerm && !isWithdrawalDone && !!item.account && !item.isSendBonus && (
                    <ActionsButton edit buttonId="actionsEditValue" onClickFunc={toggleBonusRateModal}>
                      <EditIcon />
                    </ActionsButton>
                  )}
                </div>
              </li>
            )}

            {/* Bonus Amount */}
            {!isWithdrawal && (
              <li className="PaymentPage__top-info-item" id={`backoffice-${type}-page-detail-bonus-amount`}>
                <div>Bonus Amount</div>
                <div>
                  {!item.account ? (
                    '-'
                  ) : (
                    <>
                      {item?.bonusAmount?.amount || '0.00'}
                      {item?.bonusAmount?.currency || 'USDT'}
                    </>
                  )}
                </div>
              </li>
            )}
          </ul>

          {item?.metadata && Object.entries(item.metadata).length !== 0 && (
            <ul className="PaymentPage__additional-info-list">
              {Object.entries(item.metadata).map(metadata => {
                const EDITABLE_TEXT_FIELDS = [
                  'beneficiary_name',
                  'address',
                  'city',
                  'justBeneficiaryName',
                  'justAddress',
                  'justCity',
                ];
                const isEditableText = isWithdrawal && EDITABLE_TEXT_FIELDS.includes(metadata[0]);
                const isEditableCountry = isWithdrawal && (metadata[0] === 'country' || metadata[0] === 'justCountry');
                const isEditableIban =
                  isWithdrawal && (metadata[0] === 'iban_number' || metadata[0] === 'justIBANNumber');

                return typeof metadata[1] === 'string' ? (
                  <li
                    className="PaymentPage__top-info-item"
                    key={metadata[0]}
                    id={`backoffice-${type}-page-additional-field`}>
                    <FormattedMessage id={getMetadataTextId(metadata[0])} />
                    <div className="content">
                      {metadata[1]}
                      {hasEditMetadataPerm && isEditableText && !isWithdrawalDone && (
                        <ActionsButton
                          edit
                          buttonId="actionsEditValue"
                          onClickFunc={() =>
                            onEditWithdrawalField(getMetadataApiKey(metadata[0]), 'text', metadata[1])
                          }>
                          <EditIcon />
                        </ActionsButton>
                      )}
                      {hasEditMetadataPerm && isEditableCountry && !isWithdrawalDone && (
                        <ActionsButton
                          edit
                          buttonId="actionsEditValue"
                          onClickFunc={() =>
                            onEditWithdrawalField(getMetadataApiKey(metadata[0]), 'select', metadata[1])
                          }>
                          <EditIcon />
                        </ActionsButton>
                      )}
                      {hasEditMetadataPerm && isEditableIban && !isWithdrawalDone && (
                        <ActionsButton
                          edit
                          buttonId="actionsEditValue"
                          onClickFunc={() =>
                            onEditWithdrawalField(getMetadataApiKey(metadata[0]), 'creatable', metadata[1])
                          }>
                          <EditIcon />
                        </ActionsButton>
                      )}
                    </div>
                  </li>
                ) : null;
              })}
            </ul>
          )}

          {/* Tags */}
          {item?.tags && (
            <div className="PaymentPage__tags" id={`backoffice-${type}-page-tags`}>
              <FormattedMessage id="justTags" />
              <div className="PaymentPage__tags__inner-wrapper">
                <div className="PaymentPage__tags__inner">
                  {item?.tags.length
                    ? item?.tags.map(tag => <PaymentTag key={tag.id} title={tag.name} color={tag.color} />)
                    : '---'}
                </div>
                {hasEditTagsPerm && (
                  <ActionsButton edit buttonId="actionsEditValue" onClickFunc={toggleEditTagsModal}>
                    <EditIcon />
                  </ActionsButton>
                )}
              </div>
            </div>
          )}

          {/* buttons */}
          <div className="PaymentPage__buttons-inner">
            <Buttons />
          </div>
        </div>

        {captionSlug === 'boWithdrawal' && addons.includes('withdrawApproveSystem') && item?.approval && (
          <div className="PaymentPage__approve-wrap">
            <NavLink to={`/backoffice/withdrawals/approve/${item?.approval}`}>
              <DefaultButton textId="justApprove" type="button" filled />
            </NavLink>
          </div>
        )}

        {item.paymentProofEnabled && (
          <UserDepositProofForm status={item.paymentProofStatus ?? ''} user={item.user} isDeposit={!isWithdrawal} />
        )}

        {item.id && <UserAmountEditHistory accountId={item.id} />}
        {item.id && (
          <PaymentNotes
            id={item.id}
            paymentType={type === 'deposits' ? 'deposit' : 'withdraw'}
            fullAccess={type === 'deposits' ? perms.fullAccessDeposit : perms.fullAccessWithdraw}
          />
        )}

        {item.user && isWithdrawal && <UserTransactionsHistory userId={item.user.id} />}

        {!addons.includes('walletAccount') && item.user && isWithdrawal && (
          <UserTradingHistory userId={item.user.id} accountId={item.account.id} accountLabel={item.account.login} />
        )}

        <OperationsHistory items={item.changeSet} />

        <UserInfoPanel user={item.user} onClick={goToUser} />

        {item.canEditValue && (
          <BasicModal isOpen={isOpen} captionId="justEditAmount" onRequestClose={toggleModal}>
            <EditAmountForm
              toggleModal={toggleModal}
              id={item.id}
              amount={item.amount}
              type={isWithdrawal ? 'withdrawal' : 'deposit'}
              initialValues={{
                currentAmount: item.amount ? item.amount.amount : {},
              }}
            />
          </BasicModal>
        )}
        {!isWithdrawal && (
          <BasicModal
            isOpen={isBonusRateModalOpened}
            captionId={bonusRateModalTitle ? '' : 'justEditRate'}
            caption={bonusRateModalTitle}
            onRequestClose={toggleBonusRateModal}>
            <EditBonusRateForm
              toggleModal={toggleBonusRateModal}
              item={item}
              onRefresh={() => getItem(item.id)}
              setModalTitle={setBonusRateModalTitle}
            />
          </BasicModal>
        )}
        <BasicModal captionId="editManager" isOpen={isOpenManagerForm} onRequestClose={() => toggleManagerModal()}>
          <EditPaymentManagerForm
            onSubmitSuccess={() => toggleManagerModal()}
            id={item.id}
            type={isWithdrawal ? 'withdrawal' : 'deposit'}
          />
        </BasicModal>
        <BasicModal
          captionId={textId}
          isOpen={isOpenAdditionalFieldsForm}
          onRequestClose={() => toggleAdditionalFieldsModal()}>
          <EditAdditionalFieldsForm
            onSubmitSuccess={() => toggleAdditionalFieldsModal()}
            id={item.id}
            textId={textId}
            fieldName={fieldName}
            type={type}
            initialValues={{
              [fieldName]: fieldValue,
            }}
          />
        </BasicModal>
        <BasicModal captionId="justEditTags" isOpen={isEditTagsModalOpened} onRequestClose={toggleEditTagsModal}>
          <EditTagsForm
            existingTags={item?.tags}
            paymentType={type}
            paymentId={itemId}
            toggleModal={toggleEditTagsModal}
          />
        </BasicModal>
        <BasicModal
          captionId={getMetadataTextId(editFieldKey)}
          isOpen={isEditWithdrawalFieldOpen}
          onRequestClose={toggleEditWithdrawalFieldModal}>
          <EditWithdrawalFieldForm
            onSubmitSuccess={toggleEditWithdrawalFieldModal}
            id={item.id}
            fieldKey={editFieldKey}
            fieldType={editFieldType}
            options={editFieldOptions}
            initialValues={{
              [editFieldKey]: editFieldInitialValue,
            }}
          />
        </BasicModal>
      </PageContentPreloader>
      <style jsx global>
        {staticStyles}
      </style>
      <style jsx global>
        {dynamicStyles}
      </style>
    </PageLayout>
  );
};

PaymentPage.propTypes = {
  type: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  captionSlug: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  perms: PropTypes.object.isRequired,
  itemIsLoaded: PropTypes.bool.isRequired,
  getItem: PropTypes.func,
  idBackTo: PropTypes.string,
  Buttons: PropTypes.func,
  history: PropTypes.object.isRequired,
  addons: PropTypes.array.isRequired,
  hasEditPerm: PropTypes.bool,
  hasEditMetadataPerm: PropTypes.bool,
  hasEditStatusPerm: PropTypes.bool,
  hasEditTagsPerm: PropTypes.bool,
  theme: PropTypes.object,
  // idBackTo: PropTypes.string,
  leanpaySources: PropTypes.array,
};

PaymentPage.defaultProps = {
  idBackTo: 'justBack',
  getItem: null,
  Buttons: null,
  hasEditPerm: false,
  hasEditMetadataPerm: false,
  hasEditStatusPerm: false,
  hasEditTagsPerm: false,
  theme: {},
  leanpaySources: [],
};

export default compose(
  withTheme(),
  connect(state => ({
    addons: state.interfaceConfig.addons,
    features: state.interfaceConfig.features,
    perms: state.user.profile.perms,
  }))
)(PaymentPage);
export { PaymentPage };
